
export const MESSAGES_ROUTE = 'app/messages';
export const MESSAGES_PATH = `/${MESSAGES_ROUTE}`;
export const COMMUNITY_PATH = '/app/community';

export function messagesThreadPath(threadId: string | number) {
  return `${MESSAGES_PATH}/${threadId}`;
}

export function messagesNewConversationPath(userId: string | number) {
  return `${MESSAGES_PATH}/new?userId=${encodeURIComponent(userId)}`;
}

export function isMessagesPath(pathname: string) {
  return pathname === MESSAGES_PATH || pathname.startsWith(`${MESSAGES_PATH}/`);
}
